import React, { useCallback } from 'react';

import { activitySectors } from 'utils/formData';
import { texts } from 'utils/languages/fr';

import {
    MemoizedActivitySectorsSelect,
    MemoizedTextField,
} from '../memoized-components/MemoizedComponents';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    field: { width: '100%', maxWidth: theme.constants.tunnelInputWidth },
}));

const SituationFormFPCIPM = ({ situation, onChange, errors, tunnelErrors }) => {
    const classes = useStyles();

    const handleChange = useCallback(
        e => {
            const { name, value } = e.target;
            onChange(name, value);
        },
        [onChange]
    );

    if (!situation) {
        return null;
    }

    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                {texts.SITUATION}
            </Typography>

            <MemoizedTextField
                name="profession"
                value={situation.profession}
                onChange={handleChange}
                label={texts.PROFESSION}
                inputStyle={classes.field}
                error={errors.profession || tunnelErrors.jobTitle}
                showError={!tunnelErrors.jobTitle}
            />

            <MemoizedActivitySectorsSelect
                name="activitySector"
                value={situation.activitySector}
                onChange={handleChange}
                label={texts.ACTIVITY_SECTOR}
                inputStyle={classes.field}
                error={errors.activitySector}
                selected={activitySectors[0].name}
            />
        </React.Fragment>
    );
};

export default SituationFormFPCIPM;
